import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-319130a0"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["innerHTML"];
import { ref, onMounted } from 'vue';
import { agreement } from '@/api/informationSafety/agreement';
import { useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'ChildrenPrivacyAgreement',
  setup(__props) {
    const msg = ref('');
    const router = useRouter();
    // const handleClose = () => {
    //     // router.push({
    //     //     path: '/privacyAgreement',
    //     // })
    //     router.go(-1)
    // }
    onMounted(() => {
      childrenPrivacyAgreement();
    });
    const childrenPrivacyAgreement = async () => {
      const request = {
        agreeCode: 'childPrivacy'
      };
      const {
        code,
        data,
        message
      } = await agreement(request);
      if (code === 9000) {
        msg.value = data.authAgreeContent;
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
        class: "agreement-wrap",
        innerHTML: msg.value
      }, null, 8, _hoisted_1)]);
    };
  }
});